import React, { useEffect, useRef } from 'react';

function GoUpBtn(props) {
    function handleClick(event) {
        window.$(event.currentTarget.parentElement.parentElement).animate({scrollTop: 0}, 800);
    }

    const el = useRef(null);
    useEffect(function() {
        const goUpBtn = el.current;
        const container = goUpBtn.closest('.go-up-arrow-on-overflow');
        // Aggiungi il gestore evento scroll al bottone
        container.addEventListener("scroll", function () {
            if (container.scrollTop > 0) {
                goUpBtn.style.visibility = "visible";
                goUpBtn.style.opacity = 1;
            } else if (container.scrollTop === 0) {
                goUpBtn.style.visibility = "hidden";
                goUpBtn.style.opacity = 0;
            }
        });
    }, []);

    return (
        <div ref={el} className="up-arrow-on-overflow pointer">
            <div onClick={handleClick}>
                <i className="fas fa-chevron-up fa-2x"></i>
            </div>
        </div>
    );
}

export default GoUpBtn;